// Enumy

export enum DemandType {
    SEAT = 'demandSeat',
    TRADE = 'demandTrade',
}

export enum TradeType {
    MAIN = 'main',
    SECONDARY = 'secondary',
}

export enum Residency {
    EU_CITIZEN = 'euCitizen',
    CZ_RESIDENCY = 'czResidency',
    NO_CZ_RESIDENCY = 'noCzResidency',
}

export enum EconomicActivity {
    PRIMARY = 'primary',
    EMPLOYED = 'employed',
    STUDENT = 'student',
    SOCIAL_BENEFITS = 'benefits',
}

// Produkt

export interface Product {
    type: string;
    name: string;
    code: string;
    amount: number;
    priceWithVat: string;
    priceWithoutVat: string;
    vatRate: number;
    amountUnit: number;
    jakeIsId: string;
}

// Základní demand (PHP: Demand)
export interface Demand {
    type: DemandType;
    email: string;
    phone: string;
    note: string;

    firstName: string;
    lastName: string;
    faStreet: string;
    faCity: string;
    faCountry: string;
    faZipCode: string;
    sourceUrl: string;
    sourceWeb: string;
    currency: string;

    products: Product[];

    lang: string;
    totalPriceWithVat: string;
    totalPriceWithoutVat: string;
}

// Rozšířený TradeDemand
export interface TradeDemand extends Demand {
    tradeName: string;
    tradeType: TradeType;
    taxReturn: boolean;
    taxRegistration: boolean;
    insuranceNumber: string;

    ownSeatStreet?: string | null;
    ownSeatCity?: string | null;
    ownSeatZipCode?: string | null;
    ownSeatCountry?: string | null;

    residency: Residency;
    economicActivity: EconomicActivity;
    personalInformationAgreement: string;
}